<template>
  <section class="partner-form">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2" style="padding: 50px">
          <div class="row">
            <div class="col-lg-12">
              <h2>Hotel Partner Equiry</h2>
              <p>Questions? Feedback? We want to hear from you! Email us at info@opencabana.com or fill out the below form and we will get back to you within 24 hours.</p>
            </div><!-- end .col-lg-12 -->
          </div><!-- end .row -->

          <el-form v-loading="loading" id="postForm" ref="postForm" :model="postForm" :rules="rules">
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :error="p__errors.hname" label="Hotel Name" prop="hname">
                  <el-input v-model="postForm.hname" type="text" class="article-textarea"/>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :error="p__errors.fname" label="First Name" prop="fname">
                  <el-input v-model="postForm.fname" type="text" class="article-textarea"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :error="p__errors.lname" label="Last Name" prop="lname">
                  <el-input v-model="postForm.lname" type="text" class="article-textarea"/>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :error="p__errors.title" label="Title" prop="title">
                  <el-input v-model="postForm.title" type="text" class="article-textarea"/>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :error="p__errors.email" label="Email" prop="email">
                  <el-input v-model="postForm.email" type="text" class="article-textarea"/>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :error="p__errors.info" label="Additional Information" prop="info">
                  <el-input v-model="postForm.info" type="textarea" class="article-textarea" :rows="10"/>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20" style="float:right">
              <el-col :span="9">
                <el-button type="primary" @click="submitForm" class="btn btn-primary">Submit</el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { store } from '@/api/hotel_partner'

const defaultForm = {
  hname: '',
  fname: '',
  lname: '',
  title: '',
  email: '',
  info: ''
}

export default {
  name: 'HotelPartner',
  data() {
    return {
      loading: false,
      p__errors: {
      },
      postForm: Object.assign({}, defaultForm),
      rules: {
        hname: {
          'required': true,
          'message': 'Please enter Hotel Name.',
          'trigger': 'blur',
        },
        fname: {
          'required': true,
          'message': 'Please enter your First Name.',
          'trigger': 'blur',
        },
        lname: {
          'required': true,
          'message': 'Please enter your Last Name.',
          'trigger': 'blur',
        },
        title: {
          'required': true,
          'message': 'Please enter your Title.',
          'trigger': 'blur',
        },
        email: {
          'required': true,
          'message': 'Please enter your Email.',
          'trigger': 'blur',
        }
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.postForm.validate(valid => {
        if (valid) {
          this.loading = true
          store(this.postForm).then(response => {
            if (response.data.success === true) {
              this.flashSuccess(response.data.message)
              this.$router.push('home')
            } else {
              this.validationErrors(response.data.message)
            }
            this.loading = false
          }).catch(err => {
            console.log(err)
          })
        } else {
          this.validationScrollTo('#postForm')
          return false
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?036bc134